import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import RouteRule from 'components/Admin/RouteRuleManagement';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <RouteRule />
      </SiteContent>
    </ContentLayout>
  );
};
